/**
 * @generated SignedSource<<e20def5c829a63c3550618a5a74bab1a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_IssueNavigatorUI_project$data = {
  readonly projectType: JiraProjectType | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_Header_project" | "main_issueNavigator_IssueResults_project" | "main_issueNavigator_SidebarLayout_project" | "topBar_issueNavigator_project">;
  readonly " $fragmentType": "main_issueNavigator_IssueNavigatorUI_project";
};
export type main_issueNavigator_IssueNavigatorUI_project$key = {
  readonly " $data"?: main_issueNavigator_IssueNavigatorUI_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_IssueNavigatorUI_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "main_issueNavigator_IssueNavigatorUI_project",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isConditionalFormattingEnabled",
          "variableName": "isConditionalFormattingEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "main_issueNavigator_IssueResults_project"
    },
    {
      "kind": "FragmentSpread",
      "name": "topBar_issueNavigator_project"
    },
    {
      "kind": "FragmentSpread",
      "name": "main_issueNavigator_Header_project"
    },
    {
      "kind": "FragmentSpread",
      "name": "main_issueNavigator_SidebarLayout_project"
    },
    {
      "kind": "ScalarField",
      "name": "projectType"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "ccdb82be9a13fe88e5f6b6d0f9d5d506";

export default node;
